const digest = '47bb24c5cfb8db22ddb7368ef2685a6a12671a9439d1b1bbc6beab16f0202afa';
const css = `._modalHeroNoRadius_1216u_1 img{border-radius:0!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'modalHeroNoRadius': '_modalHeroNoRadius_1216u_1' };
export const modalHeroNoRadius = '_modalHeroNoRadius_1216u_1';
export { css, digest };